module.exports = __webpack_public_path__ + "img/zone150350.35afbdbb.png";